const { REACT_APP_CONTEXT_PATH } = process.env;

export const gameScheduleApi = () => {
  return {
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    apiUrl: REACT_APP_CONTEXT_PATH + `/landers/schedules`,
  };
};
